import React, { useState, useEffect } from 'react';
import { teleMaintenance } from '../utils/teleMaintenance';

const TeleMaintenanceHistory = ({ client }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const loadHistory = async () => {
      if (!client?.remoteMaintenance || !client?.telemaintenance?.enabled || !client?.telemaintenance?.recipientEmail?.trim()) {
        setLoading(false);
        return;
      }

      try {
        const historyData = await teleMaintenance.getHistory(client.id);
        // Trier par date décroissante pour avoir les plus récents en premier
        const sortedHistory = (historyData || []).sort((a, b) => new Date(b.date) - new Date(a.date));
        setHistory(sortedHistory);
      } catch (error) {
        console.error('Erreur lors du chargement de l\'historique:', error);
        setHistory([]);
      } finally {
        setLoading(false);
      }
    };

    loadHistory();
  }, [client]);

  if (!client?.remoteMaintenance || !client?.telemaintenance?.enabled || !client?.telemaintenance?.recipientEmail?.trim() || loading) {
    return null;
  }

  if (history.length === 0) {
    return (
      <div className="bg-gray-50 border rounded-lg p-4 mb-4">
        <h3 className="font-medium text-gray-700 mb-2">📧 Historique Télémaintenance</h3>
        <p className="text-sm text-gray-500">Aucune demande de télémaintenance envoyée</p>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getTypeLabel = (type) => {
    const types = {
      generic: '🔧 Demande générique',
      problem: '🚨 Intervention sur problème',
      update: '📦 Montée de version',
      custom: '✏️ Demande personnalisée'
    };
    return types[type] || type;
  };

  // Afficher les 3 plus récents si pas étendu, sinon tout
  const recentHistory = isExpanded ? history : history.slice(0, 3);

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-medium text-blue-800">📧 Historique Télémaintenance ({history.length})</h3>
        {history.length > 3 && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-sm text-blue-600 hover:text-blue-800"
          >
            {isExpanded ? 'Masquer' : `Voir tout (${history.length})`}
          </button>
        )}
      </div>

      <div className="space-y-2">
        {recentHistory.map((request, index) => (
          <div key={index} className="bg-white border border-blue-100 rounded p-3">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-sm font-medium">{getTypeLabel(request.type)}</span>
                  <span className="text-xs text-gray-500">{formatDate(request.date)}</span>
                </div>
                
                <div className="text-sm text-gray-600">
                  {request.accountName && (
                    <div>Compte: <span className="font-mono">{request.accountName}</span></div>
                  )}
                  {request.reason && (
                    <div>Raison: {request.reason}</div>
                  )}
                  {request.version && (
                    <div>Version: <span className="font-mono">{request.version}</span></div>
                  )}
                </div>
              </div>
              
              <div className="text-right">
                <div className="flex items-center text-green-600">
                  <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-xs">Envoyé</span>
                </div>
                {request.messageId && (
                  <div className="text-xs text-gray-400 mt-1">
                    ID: {request.messageId.split('@')[0]}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeleMaintenanceHistory;